<template>
  <div class="product-page bg-light">
    <!-- Navigation Menu -->
    <b-navbar toggleable="lg" type="light" class="border-bottom">
      <b-container>
        <b-navbar-brand style="display: flex;flex-direction: column;justify-content: flex-end;">
          <div style="display: flex;justify-content: space-between;">
            <img @click="goToHref('home')" src="../assets/images/new-logo.png" height="40">
            <div style="line-height: 4px;font-size: 12px;color: #666;">
              <p>One stop purchase, In lCQQG !</p>
              <p>WhatsApp: +86 19166251823</p>
              <p>Add to Favorites</p>
            </div>
          </div>
        </b-navbar-brand>
      </b-container>
    </b-navbar>
    <b-navbar toggleable="lg" type="light" class="border-bottom" style="background-color: #eee;">
      <b-container>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item @click="goToHref('home')" active>Home</b-nav-item>
            <b-nav-item to="/">Product Category</b-nav-item>
            <b-nav-item @click="goToHref('news')">News</b-nav-item>
            <b-nav-item @click="goToHref('contact')">Contact Us</b-nav-item>
            <b-nav-item @click="goToHref('about')">About Us</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

    <!-- Main Content -->
    <b-container class="py-4">
      <b-row>
        <!-- Sidebar -->
        <b-col cols="12" md="3" lg="3">
          <div class="category-sidebar">
            <ul class="category-list">
              <li 
                v-for="category in categories" 
                :key="category.id" 
                class="category-item"
                :class="{ active: selectedCategory === category.id }"
                @click="selectCategory(category.id)"
              >
                {{ category.name }}
              </li>
            </ul>
          </div>
        </b-col>

        <!-- Product Grid -->
        <b-col cols="12" md="9" lg="9">
          <b-row>
            <b-col cols="12" sm="6" lg="3" xl="4" v-for="product in displayedProducts" :key="product.id" class="mb-4">
              <router-link style="text-decoration: none;" :to="{ name: 'ProductDetail', params: { category: product.type, id: product.id } }">
              <div class="product-card">
                <img :src="$GLOBAL_CONSTANT + product.url" class="product-image">
                <div class="product-info">
                  <div class="product-name">{{ product.name }}</div>
                  <div class="product-description" v-html="product.contents"></div>
                </div>
              </div>
            </router-link>
            </b-col>
          </b-row>

          <!-- Pagination -->
          <div class="pagination-wrapper">
            <b-pagination
              v-model="currentPage"
              :total-rows="filteredProducts.length"
              :per-page="perPage"
              first-text="«"
              prev-text="‹"
              next-text="›"
              last-text="»"
              class="custom-pagination"
              @change="handlePageChange"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- Footer -->
    <footer class="mt-5 py-4 pb-5" style="background-color: rgb(236, 236, 236);">
      <div class="container">
        <!-- Contact Form -->
      <div class="row mt-5">
        <div class="col-12">
          <div class="contact-form border-bottom pb-4">
            <h3 class="h4 mb-4">Welcome To Leave Us A Message</h3>
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.name" placeholder="Your name *">
                </div>
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.email" placeholder="Email or phone *">
                </div>
                <div class="col-md-2 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.company" placeholder="Your Company">
                </div>
                <div class="col-md-4 mb-3">
                  <input type="text" class="form-control" v-model="quoteForms.message" placeholder="Your Message *">
                </div>
                <div class="col-md-2 mb-3">
                  <button style="height: 95%;" type="submit" class="btn btn-primary w-100">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-md-7">
            <h4 class="h5">Product Category</h4>
            <ul class="list-unstyled mt-4">
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-7' } }" class="text-decoration-none">ConnectX-7</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-6' } }" class="text-decoration-none">ConnectX-6</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-5' } }" class="text-decoration-none">ConnectX-5</router-link></li>
  <li><router-link :to="{ name: 'ProductList', query: { category: 'ConnectX-4' } }" class="text-decoration-none">ConnectX-4</router-link></li>
</ul>
          </div>
          <div class="col-md-3 text-center border-start border-end">
            <p class="mb-2">+86 19166251823</p>
            <p style="color: rgb(157, 159, 162);">ShangHai Mon-Fri 9:30-19:30</p>
            <button class="btn-outline-secondary btn-sm" style="border-radius: 50px;padding: 5px 15px;color: rgb(157, 159, 162);border: 1px solid rgb(157, 159, 162);">
              <img style="margin-right: 10px;" src="../assets/images/4.png">Online
            </button>
          </div>
          <div class="col-md-2 text-center" style="color: rgb(157, 159, 162);">
            <p class="mb-2">WeChat</p>
            <img src="../assets/images/5.png" style="width: 120px;">
          </div>
        </div>
      </div>
    </footer>

    <global-component></global-component>
  </div>
</template>

<script>
import api from '../api/api';

export default {
  name: 'ProductList',
  props: ['category'],
  data() {
    return {
      currentPage: 1,
      perPage: 12,
      selectedCategory: '',
      categories: [
        { id: '', name: 'Product Category' },
        { id: 'ConnectX-7', name: 'ConnectX-7' },
        { id: 'ConnectX-6', name: 'ConnectX-6' },
        { id: 'ConnectX-5', name: 'ConnectX-5' },
        { id: 'ConnectX-4', name: 'ConnectX-4' },
      ],
      quoteForms: {
        name: '',
        email: '',
        company: '',
        message: '',
        type: 2
      },
      allProducts: [],
      cacheTimestamp: 0,
      cacheExpiryTime: 60 * 60 * 1000 // 缓存过期时间：1小时
    }
  },
  created() {
    this.loadProductsFromCache();
    this.fetchProducts();
  },
  computed: {
    filteredProducts() {
      if (!this.selectedCategory) {
        return this.allProducts;
      }
      return this.allProducts.filter(product => product.type === this.selectedCategory);
    },
    displayedProducts() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredProducts.slice(start, end);
    }
  },
  mounted() {
    if (this.category) {
      // 根据 category 设置默认选中的分类
      this.selectCategory(this.category);
    }
  },
  methods: {
    // 从缓存加载产品列表
    loadProductsFromCache() {
      try {
        const cachedData = localStorage.getItem('productsCache');
        if (cachedData) {
          const { products, timestamp } = JSON.parse(cachedData);
          // 检查缓存是否过期
          if (timestamp && Date.now() - timestamp < this.cacheExpiryTime) {
            this.allProducts = products;
            this.cacheTimestamp = timestamp;
            console.log('Products loaded from cache');
          } else {
            // 缓存过期，清除旧缓存
            localStorage.removeItem('productsCache');
            console.log('Cache expired, removed old cache');
          }
        }
      } catch (error) {
        console.error('Error loading products from cache:', error);
        // 如果解析缓存出错，则清除缓存
        localStorage.removeItem('productsCache');
      }
    },
    
    // 更新缓存
    updateCache(products) {
      try {
        const cacheData = {
          products: products,
          timestamp: Date.now()
        };
        localStorage.setItem('productsCache', JSON.stringify(cacheData));
        this.cacheTimestamp = cacheData.timestamp;
        console.log('Products cache updated');
      } catch (error) {
        console.error('Error updating products cache:', error);
      }
    },
    
    // 比较数据是否相同
    isDataDifferent(newData) {
      if (!this.allProducts || this.allProducts.length !== newData.length) {
        return true;
      }
      
      // 简单比较：检查每个产品的ID和更新时间
      for (let i = 0; i < newData.length; i++) {
        const newProduct = newData[i];
        const oldProduct = this.allProducts.find(p => p.id === newProduct.id);
        
        if (!oldProduct || oldProduct.updated_at !== newProduct.updated_at) {
          return true;
        }
      }
      
      return false;
    },
    
    async fetchProducts() {
      try {
        const response = await api.getProducts();
        const newProducts = response.data;
        
        // 检查新数据与缓存数据是否不同
        if (this.isDataDifferent(newProducts)) {
          this.allProducts = newProducts;
          this.updateCache(newProducts);
          console.log('Products data updated from API');
        } else {
          console.log('Products data unchanged, using cached data');
        }
      } catch (error) {
        console.error('There was an error fetching the products:', error);
        // 如果API请求失败但有缓存数据，则继续使用缓存数据
        if (this.allProducts.length === 0) {
          this.loadProductsFromCache();
        }
      }
    },
    selectCategory(categoryId) {
      this.selectedCategory = this.selectedCategory === categoryId ? null : categoryId;
      this.currentPage = 1; // 重置页码
    },
    showAllProducts() {
      this.selectedCategory = null;
      this.currentPage = 1;
    },
    handlePageChange(page) {
      this.currentPage = page;
      window.scrollTo(0, 0);
    },
    getSpeedClass(specs) {
      if (specs.includes('400GbE')) {
        return 'speed-400g';
      } else if (specs.includes('200GbE')) {
        return 'speed-200g';
      }
      return 'speed-100g';
    },
    viewProductDetails(id) {
      this.$router.push(`/product/${id}`);
    },
    async submitForm() {
      if (!this.quoteForms.name || !this.quoteForms.message || !this.quoteForms.email) {
          this.$mMessage.error("Please fill in all required fields.");
          return;
        }
        const myreg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if(!myreg.test(this.quoteForms.email)){
          this.$mMessage.error("email is not valid.");
          return;
        }
        try {
          const response = await api.addFormSubmit(this.quoteForms);
          console.log('Quote submitted successfully:', response.data);
          // 显示成功消息
          this.$mMessage.success("Message submitted successfully!");
          // 关闭模态框
          // this.showQuoteModal = false;
          // 重置表单
          this.quoteForms.name = '';
          this.quoteForms.email = '';
          this.quoteForms.company = '';
          this.quoteForms.message = '';
        } catch (error) {
          console.error('There was an error submitting the quote:', error);
          // 显示错误消息
          // this.$toast.error("Failed to submit quote. Please try again.");
        }
      },
      goToHref(type) {
        if(type == 'home') {
          window.location.href = 'https://en.icqqg.com';
        } else if(type == 'contact') {
          window.location.href = 'https://en.icqqg.com/bom';
        } else if(type == 'about') {
          window.location.href = 'https://en.icqqg.com/about';
        } else if(type == 'news') {
          window.location.href = 'https://en.icqqg.com/news/type/1';
        }
      }
  }
}
</script>

<style>
.product-page {
  background-color: white;
  width: 100%;
  height: 100%;
}

.category-sidebar {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.category-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
}

.category-item {
  padding: 15px 15px 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
}

.category-item:hover {
  color: white;
  background-color: rgba(0,117,196);
}

.category-item.active {
  color: white;
  background-color: rgba(0,117,196);
  font-weight: 500;
}

.product-card {
  background: #fff;
  overflow: hidden;
  border: 1px solid #e9e9e9;
  height: 100%;
  border-radius: 5px;
  transition: box-shadow 0.3s;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  display: grid;
  grid-template-rows: auto 1fr; /* 第一行是自动高度，第二行填充剩余空间 */
  height: 100%;
}

.product-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  transform: scale(1.05);
}

.product-card:hover .product-image {
  transform: scale(1.1);
}

.product-image {
  width: 100%;
  height: 260px;
  object-fit: cover;
}

.product-info {
  padding: 20px 20px 0px 20px;
  text-align: center;
  background-color: #f0f0f0;
}

.product-model {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}

.product-name {
  font-size: 18px;
  color: black;
  font-weight: bold;
  margin-bottom: 8px;
}

.product-description {
  font-size: 14px;
  color: #888;
  line-height: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.product-specs {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 15px;
}

.speed-400g {
  color: #007bff;
}

.speed-200g {
  color: #28a745;
}

.speed-100g {
  color: #6c757d;
}

.view-details-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.2s;
}

.view-details-btn:hover {
  background: #0056b3;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.custom-pagination ::v-deep .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.custom-pagination ::v-deep .page-link {
  color: #333;
  border-color: #dee2e6;
  background-color: white;
}

.custom-pagination ::v-deep .page-item:not(.active) .page-link:hover {
  background-color: #e9ecef;
  color: #007bff;
}

/* Responsive Design */
@media (max-width: 768px) {
  .category-sidebar {
    margin-bottom: 2rem;
  }
  
  .product-image {
    height: 260px;
  }
}

@media (max-width: 576px) {
  .product-image {
    height: 280px;
  }
}
</style>